import * as types from './mutation-types'

export const exportGetExports = ({ commit }, options) => {
  options = _.merge({
    params: {
      per_page: 25,
    },
  }, options)

  return Vue2.prototype.$api.active().get('exports', {
    params: options.params,
  }).then((response) => {
    commit(types.EXPORT_SET_EXPORTS, response.data)
    return response
  }).catch((errors) => {
    commit('baseAddNotification', {
      type: 'error',
      text: 'There was an fetching exports.',
      timeout: false,
    })
  })
}